'use client';

import * as React from 'react';
import {
  RadixTooltip,
  RadixTooltipContent,
  RadixTooltipTrigger,
} from '../../../components/ui/tooltip';
import { cn } from '../../../lib/utils';

interface PropertyPanelMenuItemProps {
  text: string;
  iconNode: React.ReactNode;
  selectedIconNode?: React.ReactNode;
  isSelected?: boolean;
  tooltip?: React.ReactNode | boolean;
  onClick?: () => void;
  className?: string;
}

function PropertyPanelMenuItem({
  text,
  iconNode,
  selectedIconNode,
  isSelected = false,
  tooltip,
  onClick,
  className,
}: PropertyPanelMenuItemProps) {
  const resolvedTooltip = tooltip === true ? text : tooltip;
  const currentIconNode =
    isSelected && selectedIconNode ? selectedIconNode : iconNode;

  const content = (
    <button
      type="button"
      aria-pressed={isSelected}
      onClick={onClick}
      className={cn(
        'flex size-16 cursor-pointer flex-col items-center justify-center gap-4xs rounded-2xs p-4xs transition-colors focus:outline-none',
        isSelected
          ? 'bg-sys-style-neutral-lightest'
          : 'hover:bg-sys-style-neutral-lightest active:bg-sys-style-neutral-light',
        className,
      )}
    >
      {currentIconNode}
      <span
        className={cn(
          'text-comp-accent-xsmall text-center leading-tight whitespace-normal break-keep',
          'max-w-full overflow-hidden [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical]',
          isSelected
            ? 'text-sys-cont-primary-default'
            : 'text-sys-cont-neutral-default',
        )}
      >
        {text}
      </span>
    </button>
  );

  if (!resolvedTooltip) {
    return content;
  }

  return (
    <RadixTooltip>
      <RadixTooltipTrigger asChild>{content}</RadixTooltipTrigger>
      <RadixTooltipContent
        side="right"
        align="center"
      >
        {resolvedTooltip}
      </RadixTooltipContent>
    </RadixTooltip>
  );
}

export { PropertyPanelMenuItem };
export type { PropertyPanelMenuItemProps };
